import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionWhyMattersPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionWhyMatters.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionWhyMatters.button1'),
          value: 'helping_planet',
        },
        {
          text: t('pages.onboarding.questionWhyMatters.button2'),
          value: 'saving_money',
        },
        {
          text: t('pages.onboarding.questionWhyMatters.button3'),
          value: 'less_stress',
        },
        {
          text: t('pages.onboarding.questionWhyMatters.button4'),
          value: 'feeling_productive',
        },
        {
          text: t('pages.onboarding.questionWhyMatters.button5'),
          value: 'setting_example',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
